import { render, staticRenderFns } from "./TimeSyncStreamax.vue?vue&type=template&id=d9d6f404&scoped=true&"
import script from "./TimeSyncStreamax.vue?vue&type=script&lang=ts&"
export * from "./TimeSyncStreamax.vue?vue&type=script&lang=ts&"
import style0 from "./TimeSyncStreamax.vue?vue&type=style&index=0&id=d9d6f404&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9d6f404",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('d9d6f404', component.options)
    } else {
      api.reload('d9d6f404', component.options)
    }
    module.hot.accept("./TimeSyncStreamax.vue?vue&type=template&id=d9d6f404&scoped=true&", function () {
      api.rerender('d9d6f404', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/ConfiguracionCamaras/Streamax/TimeSetup/TimeSyncStreamax.vue"
export default component.exports